import { browserName } from 'mobile-device-detect'

export const handleSamsungBrowser = () => {
  if (browserName != 'Samsung Browser') return

  window.document.documentElement.style.overflow = 'hidden'
  document.body.style.width = '100vw'
  document.body.style.height = '100vh'
  document.body.style.overflowX = 'auto'
  document.body.style.overflowY = 'hidden'
}
